/**
 * Generated runtime TestId mirror for frontend/src/pages/CertificationPolicyDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const CertificationPolicyDetailTestIds = {
  badgeCampaignCount: "badge-campaign-count",
  btnCreateCampaign: "btn-create-campaign",
  btnDelete: "btn-delete",
  btnEditBasics: "btn-edit-basics",
  btnEditReviewSettings: "btn-edit-review-settings",
  btnEditScope: "btn-edit-scope",
  certificationPolicyDetailPage: "certification-policy-detail-page",
  infoDefaultPolicy: "info-default-policy",
  infoOpenCampaignWarning: "info-open-campaign-warning",
  policyOwner: "policy-owner",
  sectionBasics: "section-basics",
  sectionBasicsTitle: "section-basics-title",
  sectionReviewSettings: "section-review-settings",
  sectionReviewSettingsTitle: "section-review-settings-title",
  sectionScope: "section-scope",
  sectionScopeTitle: "section-scope-title"
} as const;
